import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

import SourceLink from 'components/SourceLink';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          © 2020 Made with ❤ By <SourceLink>SDS</SourceLink>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
